import React, { useState } from 'react';
import { Thread } from '../components/assistant/Thread';
import { Composer } from '../components/assistant/Composer';
import { MessageProps } from '../components/assistant/Message';
import { Header } from '../components/Header';
import { copy } from '../copy';
export function ChatPage() {
  const [view, setView] = useState<'showcase' | 'agentic'>('showcase');
  const [messages, setMessages] = useState<MessageProps[]>(copy.chat.showcaseMessages as MessageProps[]);
  const [isTyping, setIsTyping] = useState(false);
  const handleSend = (content: string) => {
    setIsTyping(true);
    setView('agentic');
    const userMsg: MessageProps = {
      role: 'user',
      content
    };
    const initialAgenticMsg: MessageProps = {
      role: 'assistant',
      content: '',
      steps: [{
        type: 'thinking',
        label: copy.chat.agentic.initialStep
      }]
    };
    setMessages([userMsg, initialAgenticMsg]);
    setTimeout(() => {
      setMessages(prev => {
        const next = [...prev];
        if (next.length >= 2) {
          next[1] = {
            ...next[1],
            steps: [...copy.chat.agentic.seq1]
          };
        }
        return next;
      });
      setTimeout(() => {
        setMessages(prev => {
          const next = [...prev];
          if (next.length >= 2) {
            next[1] = {
              ...next[1],
              steps: [...copy.chat.agentic.seq2]
            };
          }
          return next;
        });
        setTimeout(() => {
          setMessages(prev => {
            const next = [...prev];
            if (next.length >= 2) {
              next[1] = {
                ...next[1],
                steps: [...copy.chat.agentic.seq3Steps],
                content: copy.chat.agentic.finalContent,
                sources: [...copy.chat.agentic.finalSources]
              };
            }
            return next;
          });
          setIsTyping(false);
        }, 2500);
      }, 2000);
    }, 1000);
  };
  return <div className="flex h-screen flex-col bg-white dark:bg-[#1a1a1a]" data-id="element-266">
      <Header title="Reviewing Motion to Suppress" minimal showBackArrow backTo="/case" data-id="element-267" />

      <main className="flex-1 overflow-y-auto" data-id="element-268">
        <Thread messages={messages} data-id="element-269" />
      </main>

      <Composer onSend={handleSend} disabled={isTyping} data-id="element-270" />
    </div>;
}